"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _withScopeId = (n) => ((0, vue_2.pushScopeId)("data-v-d6a29fa4"), n = n(), (0, vue_2.popScopeId)(), n);
const _hoisted_1 = { id: "slot-modal-roles" };
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "divider slot-modal-divider" }, null, -1 /* HOISTED */));
const _hoisted_3 = {
    key: 0,
    class: "accordion"
};
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("input", {
    type: "checkbox",
    id: "accordion-roles",
    name: "accordion-checkbox",
    hidden: "",
    checked: ""
}, null, -1 /* HOISTED */));
const _hoisted_5 = {
    class: "accordion-role-header-container",
    id: "accordion-role-header-container"
};
const _hoisted_6 = { class: "header-left d-flex" };
const _hoisted_7 = { for: "accordion-roles" };
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "icon icon-arrow-right mr-1" }, null, -1 /* HOISTED */));
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("div", { class: "header-right d-flex" }, [
    /*#__PURE__*/ (0, vue_2.createCommentVNode)(" Todo: refactor these search functions, its currently in dashboard base "),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("input", {
        id: "role-search-bar",
        type: "text",
        class: "form-input search-bar",
        oninput: "handleRoleSearch(this.value)"
    }),
    /*#__PURE__*/ (0, vue_2.createElementVNode)("button", {
        id: "role-search-btn",
        class: "btn",
        onclick: "handleRoleSearchClick()"
    }, [
        /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "icon icon-search" })
    ])
], -1 /* HOISTED */));
const _hoisted_10 = {
    key: 0,
    class: "loading"
};
const _hoisted_11 = {
    key: 1,
    class: "accordion-body role-accordion-body"
};
const _hoisted_12 = ["data-tooltip", "onClick", "id", "title"];
const _hoisted_13 = {
    key: 0,
    class: "svg-container"
};
const _hoisted_14 = { class: "role-name-container" };
const _hoisted_15 = { key: 1 };
const _hoisted_16 = { class: "empty centered" };
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ (0, vue_2.createElementVNode)("p", { class: "empty-title h5" }, null, -1 /* HOISTED */));
const _hoisted_18 = { class: "empty-subtitle" };
const vue_3 = require("vue");
const vue_i18n_1 = require("vue-i18n");
const GroupRoleIcon_vue_1 = __importDefault(require("../../vue/icons/GroupRoleIcon.vue"));
const models_1 = require("../../js/models");
const summary_lib_1 = require("../../js/summary_lib");
const injectionKeys_1 = require("../types/injectionKeys");
exports.default = (0, vue_1.defineComponent)({
    __name: 'SlotModalRolesList',
    setup(__props) {
        // This component is currently rendered inside SlotModal
        const { t } = (0, vue_i18n_1.useI18n)();
        const injectedProps = (0, vue_3.inject)(injectionKeys_1.SlotModalRoleListInjectionKey);
        const { updateCurrentDate, currentDateTimestampSec } = (0, vue_3.inject)("currentDate", {
            updateCurrentDate: (dateTimestamp) => { },
            currentDateTimestampSec: (0, vue_3.ref)(0),
        });
        const rolesList = (0, vue_3.computed)(() => {
            if (!injectedProps?.value.rolesList) {
                return [];
            }
            return injectedProps.value.rolesList.filter(r => {
                if (injectedProps?.value.filterHiddenRoles) {
                    return !r.isHiddenInShiftPage;
                }
                return r;
            });
        });
        function roleBtnClass(role) {
            const isNonWorkingRole = role.slotType === 2 || role.slotType === 6 || role.slotType === 7;
            const isDisabled = isRoleSelectDisabled(role.getOriginalId());
            return {
                "slot-type-non-working": isNonWorkingRole,
                "select-disabled": isDisabled,
                "tooltip": isDisabled,
            };
        }
        function roleColor(role) {
            if (!role || !role.color || role.color === models_1.OPLUS_COLOR_PALETTE.DEFAULT) {
                return;
            }
            const style = {
                backgroundColor: `#${role.color}`,
                color: "#fff"
            };
            return style;
        }
        function handleRoleSelect(role) {
            if (isRoleSelectDisabled(role.getOriginalId())) {
                return;
            }
            emitRoleId(role.getId());
        }
        function emitRoleId(roleId) {
            (0, summary_lib_1.setRoleIdToSlotModal)(roleId);
            return;
        }
        function isRoleSelectDisabled(roleId) {
            return !(injectedProps?.value.roleDates?.[roleId]?.[currentDateTimestampSec.value]?.ShouldShow ?? true);
        }
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                _hoisted_2,
                (rolesList.value.length)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_3, [
                        _hoisted_4,
                        (0, vue_2.createElementVNode)("div", _hoisted_5, [
                            (0, vue_2.createElementVNode)("div", _hoisted_6, [
                                (0, vue_2.createElementVNode)("label", _hoisted_7, [
                                    (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(t)('slot_modal.roles_label', { count: rolesList.value.length })) + " ", 1 /* TEXT */),
                                    _hoisted_8
                                ])
                            ]),
                            _hoisted_9
                        ]),
                        ((0, vue_2.unref)(injectedProps)?.isLoading)
                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_10))
                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_11, [
                                ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(rolesList.value, (role) => {
                                    return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("button", {
                                        class: (0, vue_2.normalizeClass)(["btn chip slot-modal-role-btn slot-modal-role", roleBtnClass(role)]),
                                        "data-tooltip": (0, vue_2.unref)(t)('shift.add_disabled_tooltip'),
                                        onClick: ($event) => (handleRoleSelect(role)),
                                        key: role.getId(),
                                        id: `slot-modal-role-${role.getId()}`,
                                        style: (0, vue_2.normalizeStyle)(roleColor(role)),
                                        title: role.getName()
                                    }, [
                                        (role.isGroupRole)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_13, [
                                                (0, vue_2.createVNode)(GroupRoleIcon_vue_1.default)
                                            ]))
                                            : (0, vue_2.createCommentVNode)("v-if", true),
                                        (0, vue_2.createElementVNode)("div", _hoisted_14, (0, vue_2.toDisplayString)(role.getName()), 1 /* TEXT */)
                                    ], 14 /* CLASS, STYLE, PROPS */, _hoisted_12));
                                }), 128 /* KEYED_FRAGMENT */))
                            ]))
                    ]))
                    : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_15, [
                        (0, vue_2.createElementVNode)("div", _hoisted_16, [
                            _hoisted_17,
                            (0, vue_2.createElementVNode)("p", _hoisted_18, (0, vue_2.toDisplayString)((0, vue_2.unref)(t)('slot_modal.no_roles')), 1 /* TEXT */)
                        ])
                    ]))
            ]));
        };
    }
});
